export const IsApprovedDomainRegex =
    /^(https:\/\/)?((www\.)?(dev\.|test\.)?webstaurantstore|www\.(dev\.|test\.)?therestaurantstore)\.com[a-zA-Z0-9@:%_+.~#?&/=*-]*$/;
